import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
import { useOnboardingActivationStatus } from '../liveEvents/liveEventQueries';
import { ACADEMY_PORTAL_ID } from './accountsConstants';
import { useHasScope } from './accountsQueries';
const AO_SCOPE = 'academy-onboarding';
export const useHasAcademyOnboardingAccess = ({
  requireEligibilityWindow = false
} = {}) => {
  const isAcademyPortal = enviro.isProd() && PortalIdParser.get() === ACADEMY_PORTAL_ID;
  const {
    hasScope,
    gatesAndScopesLoading: scopeLoading
  } = useHasScope(AO_SCOPE);
  const {
    isWithinActivationWindow,
    loading: activationStatusLoading
  } = useOnboardingActivationStatus({
    skip: !requireEligibilityWindow || !hasScope
  });
  const isLoading = !isAcademyPortal && (scopeLoading || requireEligibilityWindow && activationStatusLoading);
  const withinEligibilityWindow = !requireEligibilityWindow || isWithinActivationWindow;
  const hasAccess = isAcademyPortal || !isLoading && hasScope === true && withinEligibilityWindow;
  return {
    hasAccess,
    isLoading
  };
};